'use client';
import MainSidebar from '@/app/components/common/MainSidebar';
import ErrorBoundary from '@/app/components/common/ErrorBoundary';
import { NavigationGuardProvider } from '@/app/context/navigation-guard';
import { SidebarProvider } from '@/app/context/sidebar';
import { SignalCountProvider } from '@/app/context/signal-count';
import ProtectedRoute from '@/app/components/ProtectedRoute';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import Toaster from '../components/ui/Toaster';
import IntercomProvider from '../components/common/IntercomProvider';
import { cn } from '@/app/lib/utils';
import { usePathname } from 'next/navigation';
import ContactDetailsDrawerProvider from '@/app/components/contact/ContactDetailsDrawerProvider';

function LayoutContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isGlobalPage =
    pathname.startsWith('/dashboard') ||
    pathname.startsWith('/agency') ||
    pathname.startsWith('/setup');
  return (
    <div className="h-svh flex overflow-hidden">
      {!isGlobalPage && <MainSidebar />}
      <div className={cn('flex-1 flex flex-col overflow-hidden duration-300')}>
        <div className="flex-1 flex overflow-y-auto">
          <ErrorBoundary key={pathname}>{children}</ErrorBoundary>
        </div>
      </div>
    </div>
  );
}

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <NavigationGuardProvider>
      <ProtectedRoute>
        <IntercomProvider>
          <TooltipProvider>
            <SidebarProvider>
              <SignalCountProvider>
                <ContactDetailsDrawerProvider>
                  <LayoutContent>{children}</LayoutContent>
                </ContactDetailsDrawerProvider>
              </SignalCountProvider>
            </SidebarProvider>
          </TooltipProvider>
          <Toaster additionalViewPortClassName="top-4 left-[50%] translate-x-[-50%]" />
        </IntercomProvider>
      </ProtectedRoute>
    </NavigationGuardProvider>
  );
}
